import bee from "./Bee";
export default {
    name: "Promotions",
    /*
        var query = {
           
        }
    */
    /* eslint-disable no-unused-vars */
    // get_featured_promotions(query, success, fail) {
    //     bee.get()
    //     //nyd 
    //     //for now just do this
    //     success([{
    //         id: 34,
    //         title: 'Sep Month End It is what i want to tell all of you',
    //         business: {
    //             id: 4,
    //             name: "Choopies (pty) Ltd"
    //         }
    //     }, {
    //         id: 35,
    //         title: 'Greate Savings Season',
    //         business: {
    //             id: 4,
    //             name: "Sefalana General Dearlers (pty) ltd"
    //         }
    //     }]);
    // },
    /*
        var query = {
            promotion_id: 3,
            user_id: 34,
            page: "",
            section: ""
        }
    */
    /* eslint-disable no-unused-vars */
    record_clicked_featured_promotion(query, success, fail) {
        //context: "featured_promotion"
        bee.post({
            promotion_view: {
                ...query,
                context: "featured_promotion",
                _date_view_on: "",
                _now_view_on_timestamp: ""
            }
        })
            .then(res => {
                if (success) {
                    success(res.promotion_view);
                    //nyd
                    //build a report under admin side for this
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        e.g the android app advert
        var query = {
            advert_name: 3,
            user_id: 34,
            page: "",
            section: ""
        }
    */
    /* eslint-disable no-unused-vars */
    record_clicked_self_promotion(query, success, fail) {

        bee.post({
            self_promotion_click: {
                ...query,
                _date_view_on: "",
                _now_view_on_timestamp: ""
            }
        })
            .then(res => {
                if (success) {
                    success(res.self_promotion_click);
                    //nyd
                    //build a report under admin side for this
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_new_count(query, success, fail) {
        bee.get({
            promotions: {
                _a: " _count ",
                _w: [
                    ["has_been_ended", "e", 0]
                ]
            }
        }).then(
            res => {
                if (success) {
                    success(res.promotions[0].count);
                }
            }
        ).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            business_id: 3,
            title: "",
            description: "",
            media_url: "",
            thumbnail_url: "",
            starts_on: "",
            ends_on: "",
        }
    */
    /* eslint-disable no-unused-vars */
    create_promotion(query, success, fail) {
        bee.post({
            promotion: {
                ...query,
                views_count: 0,
                has_been_ended: 0,
                auto_end: 0,
                has_ended_automatically: 0,
                banner_url: query.media_url,
                _date_posted_on: "",
                _now_posted_on_timestamp: "",
                ended_on: "1989-01-01",
                _time_ended_on_timestamp: "1989-01-01",
            }
        }).then(
            res => {
                if (success) {
                    success(res.promotion);
                }
            }
        ).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
        }
    */
    /* eslint-disable no-unused-vars */
    get_promotions(query, success, fail) {
        bee.get({
            promotions: {
                business: {
                    _a: "id name"
                },
                _desc: ["starts_on_timestamp"]
            }
        })
            .then(res => {
                if (success) {
                    success(res.promotions);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
        }
    */
    /* eslint-disable no-unused-vars */
    get_featured_promotions(query, success, fail) {
        bee.get({
            featured_promotions: {
                promotion: {},
                business: {
                    _a: "id name"
                },
                user: {

                },
                _desc: ["id"]
            }
        })
            .then(res => {
                if (success) {
                    success(res.featured_promotions);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_featured_promotion(query, success, fail) {
        bee.get({
            featured_promotion: {
                promotion: {
                    business: {
                        _a: "id name"
                    }
                },
                user: {

                },
                _w:[
                    ["id","e",query.id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.featured_promotion);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
           user_id: 3
        }
    */
    /* eslint-disable no-unused-vars */
    get_my_promotions(query, success, fail) {
        bee.get({
            promotions: {
                business: {
                    _a: "id name"
                },
                _desc: ["starts_on_timestamp"],
                _w: [
                    ["user_id", "e", query.user_id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.promotions);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
           id: 3,
           [get_header_only]: true
        }
    */
    /* eslint-disable no-unused-vars */
    get_promotion(query, success, fail) {
        if (query.get_header_only && query.get_header_only == true) {
            bee.get({
                promotion: {
                    business: {
                        user: {}
                    },
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
            }).then(res => {
                if (success) {
                    success(res.promotion);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
        } else {
            bee
                .que()
                .get({
                    promotion: {
                        business: {
                            user: {}
                        },
                        _w: [
                            ["id", "e", query.id]
                        ]
                    },
                    featured_promotions: {
                        _w: [
                            ["promotion_id", "e", query.id]
                        ]
                    },
                    promotion_views: {
                        _ob: ["view_on_timestamp"],
                        _w: [
                            ["promotion_id", "e", query.id]
                        ]
                    }
                }, "get_promotion")
                .get({},
                    "get_parent_branch_business"
                )
                .before("get_parent_branch_business", (index, previous_res, tasks) => {
                    //console.log("previous_res", previous_res);
                    if (previous_res.promotion && previous_res.promotion.business && parseInt(previous_res.promotion.business.is_branch_of_id) > 0) {
                        return {
                            business: {
                                _w: [
                                    ["id", "e", previous_res.promotion.business.is_branch_of_id]
                                ]
                            }
                        };
                    }
                    return "skip";
                })
                .send()
                .then(res => {
                    if (success) {
                        var b_res = res[0].response;
                        //console.log("byona ", b_res);
                        var p_branch = null;
                        if (res[1].response._skipped && res[1].response._skipped == true) {
                            //do nothing for now
                        } else {
                            p_branch = res[1].response.business;
                        }
                        b_res.promotion.business.parent_branch = p_branch;
                        success({
                            ...b_res.promotion,
                            featured_promotions: b_res.featured_promotions,
                            promotion_views: b_res.promotion_views
                        });
                    }
                })
                .catch(errors => {
                    if (fail) {
                        fail(errors);
                    }
                });
        }
    },
     /* eslint-disable no-unused-vars */
    update_promotion(query, success, fail) {
        bee.update({
            promotion: {
                ... query.data,
                _w: [
                    ["id","e",query.id]
                ]
            }
        })
        .then(res => {
            if (success) {
                success(res.promotion);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    send_delete_message(query, success, fail) {
        var message_data = {
            _box: {
                promotion_id: query.promotion_id,
                message: query.message,
                user_id: query.user_id,
                email: query.email,
                to_name: query.to_name,
                promotion_name: query.promotion_name
            },
            _f_br: "send_delete_promotion_messages"
        }
        bee.get(message_data).then(res2 => {
            console.log("Deleted promotion by admin successfully ", res2);
            if(success){
                success(true);
            }
        }).catch(errors_msg => {
            console.log("Deleted promotion by admin but sending messages got issues", errors_msg);
            if(fail){
                fail();
            }
        });
    },
    post_fetaured_promotion(query, success, fail) {
        bee
        .que()
        .get({
            featured_promotions:{
                _w:[
                    [
                        [
                            ["platform","e",query.platform],
                            "AND",
                            ["page","e",query.page]
                        ],
                        "AND",
                        ["section","e",query.section]
                    ]
                ]
            },
            adverts:{
                _w:[
                    [
                        [
                            ["platform","e",query.platform],
                            "AND",
                            ["page","e",query.page]
                        ],
                        "AND",
                        ["section","e",query.section]
                    ]
                ]
            }
        },"check_section_taken")
        .post({
            featured_promotion: {
                ... query
            }
        },"post_featuring")
        .before("post_featuring", (index, previous_res, tasks) => {
            if (parseInt(previous_res.featured_promotions.length) > 0) {
                return "skip";
            }else if(parseInt(previous_res.adverts.length) > 0) {
                return "skip";
            }

            return {
                featured_promotion: {
                    ... query
                }
            };
        })  
        .send()
        .then(res => {
            // console.log("res" , res);
            if (res[1].response._skipped && res[1].response._skipped == true) {
                if (fail) {
                    fail(["This site section is already assigned an advert or may be a promotion"]);
                    return;
                }
            } 
            if (success) {
                success(res[1].response.featured_promotion);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    update_fetaured_promotion(query, success, fail) {
        bee
        .que()
        .get({
            featured_promotions:{
                _w:[
                    [
                        [
                            [
                                ["platform","e",query.data.platform],
                                "AND",
                                ["page","e",query.data.page]
                            ],
                            "AND",
                            ["section","e",query.data.section]
                        ],
                        "AND",
                        ["id","ne",query.id]
                    ]
                ]
            },
            adverts:{
                _w:[
                    [
                        [
                            ["platform","e",query.data.platform],
                            "AND",
                            ["page","e",query.data.page]
                        ],
                        "AND",
                        ["section","e",query.data.section]
                    ]
                ]
            }
        },"check_section_taken")
        .update({
            
        },"update_featuring")
        .before("update_featuring", (index, previous_res, tasks) => {
            if (parseInt(previous_res.featured_promotions.length) > 0) {
                return "skip";
            }else if(parseInt(previous_res.adverts.length) > 0) {
                return "skip";
            } 
            return {
                featured_promotion: {
                    ... query.data,
                    _w:[
                        ["id","e",query.id]
                    ]
                }
            };
        })  
        .send()
        .then(res => {
            // console.log("res" , res);
            if (res[1].response._skipped && res[1].response._skipped == true) {
                if (fail) {
                    fail(["This site section is already assigned an advert or promotion"]);
                    return;
                }
            } 
            if (success) {
                success(res[1].response.featured_promotion);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            featured_size: 5,
            viewd_size:  5
            on_going_size: 5,
            overdue_size: 10,
            time_now: 2200,
            most_viewed_min: 150
        }
    */
    /* eslint-disable no-unused-vars */
    get_promotion_page(query, success, fail) {
        var req = {
            _julz: {
                _gets: {
                    indexed_promotions_req: {
                        promotions: {
                            business: {
                                _a: "id  name district_id",
                                district: {}
                            },
                        },
                        _index_promotions: "promotions.id"
                    }, 
                    featured_req: {
                        featured_promotions:{
                            _desc: ["id"]
                        }
                    },
                    most_viewed_req: {
                        promotions: {
                            _a: "id views_count  ",
                            _desc: ["views_count"],
                            _pg: query.viewd_size,
                            _w: [
                                ["has_been_ended","e",0]
                            ]
                        }
                    },
                    on_going_req:{
                        promotions: {
                            _a: "id has_been_ended starts_on_timestamp ends_on_timestamp ",
                            _pg: query.on_going_size,
                            _w: [
                                [
                                    [
                                        ["has_been_ended","e",0],
                                        "AND",
                                        ["starts_on_timestamp","lte", query.time_now ]
                                    ],
                                    "AND",
                                    ["ends_on_timestamp","gte", query.time_now ]
                                ]
                            ]
                        }
                    },
                    on_going_count_req:{
                        promotions: {
                            _a: " _count ",
                            _w: [
                                [
                                    [
                                        ["has_been_ended","e",0],
                                        "AND",
                                        ["starts_on_timestamp","lte", query.time_now ]
                                    ],
                                    "AND",
                                    ["ends_on_timestamp","gte", query.time_now ]
                                ]
                            ]
                        }
                    },
                    over_due_req:{
                        promotions: {
                            _a: "id has_been_ended ends_on_timestamp ",
                            _pg: query.overdue_size,
                            _w: [
                                [
                                    ["has_been_ended","e",0],
                                    "AND",
                                    ["ends_on_timestamp","lt", query.time_now ]
                                ]
                            ]
                        }
                    },
                    over_due_count_req:{
                        promotions: {
                            _a: " _count ",
                            _w: [
                                [
                                    ["has_been_ended","e",0],
                                    "AND",
                                    ["ends_on_timestamp","lt", query.time_now ]
                                ]
                            ]
                        }
                    }
                }
            }
        };
        bee.get(req)
        .then(res => {
            if (success) {
                success(res.julz.gets);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    get_promotion_group_page_dependencies(query, success, fail) {
        var req = {}; 
        if(query.group == "featured"){
            req = {
                featured_promotions:{
                    _desc: ["id"]
                }
            };
        }else if(query.group == "most_viewed"){
            req = {
                promotions: {
                    _a: "id views_count  ",
                    _desc: ["views_count"],
                    _pg: query.limit,
                    _w: [
                        ["has_been_ended","e",0]
                    ]
                }
            };
        }else if(query.group == "on_going"){
            req = {
                promotions: {
                    _a: " _count ",
                    _w: [
                        [
                            [
                                ["has_been_ended","e",0],
                                "AND",
                                ["starts_on_timestamp","lte", query.time_now ]
                            ],
                            "AND",
                            ["ends_on_timestamp","gte", query.time_now ]
                        ]
                    ]
                }
            };
        }else if(query.group == "overdue"){
            req = {
                promotions: {
                    _a: " _count ",
                    _w: [
                        [
                            ["has_been_ended","e",0],
                            "AND",
                            ["ends_on_timestamp","lte", query.time_now ]   
                        ]
                    ]
                }
            };
        }
        bee.get(req)
        .then(res => {
            var num = 0;
            if(query.group == "featured"){
                var ids = [];
                for (var index = 0; index < res.featured_promotions.length; index++) {
                    var fpromo = res.featured_promotions[index];
                    var promo_id = parseInt(fpromo.promotion_id);
                    if(ids.indexOf(promo_id) < 0){
                        ids.push(promo_id);
                    }
                }
                num = ids.length;
            }else if(query.group == "most_viewed"){
                num = res.promotions.length;
            }else if(query.group == "on_going"){
                num = res.promotions[0].count;
            }else if(query.group == "overdue"){
                num = res.promotions[0].count;
            }
            if (success) {
                success(num);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    get_promotion_group_page(query, success, fail) {
        var req = {}; 
        if(query.group == "featured"){
            req = {
                featured_promotions:{
                    promotion: {
                        business: {}
                    },
                    _desc: ["id"],
                    _pg: query.page_size + "." + query.page,
                },
                _xtu_promotions: "featured_promotions.promotion"
            };
        }else if(query.group == "most_viewed"){
            req = {
                promotions: {
                    business: {},
                    _desc: ["views_count"],
                    _pg: query.page_size + "." + query.page,
                    _w: [
                        ["has_been_ended","e",0]
                    ]
                }
            };
        }else if(query.group == "on_going"){
            req = {
                promotions: {
                    business: {},
                    _desc: ["starts_on_timestamp"],
                    _pg: query.page_size + "." + query.page,
                    _w: [
                        [
                            [
                                ["has_been_ended","e",0],
                                "AND",
                                ["starts_on_timestamp","lte", query.time_now ]
                            ],
                            "AND",
                            ["ends_on_timestamp","gte", query.time_now ]
                        ]
                    ]
                }
            };
        }else if(query.group == "overdue"){
            req = {
                promotions: {
                    business: {},
                    _desc: ["ends_on_timestamp"],
                    _pg: query.page_size + "." + query.page,
                    _w: [
                        [
                            ["has_been_ended","e",0],
                            "AND",
                            ["ends_on_timestamp","lte", query.time_now ]   
                        ]
                    ]
                }
            };
        }
        //console.log("Group rRequest ", req);
        req["_box"] = {
            ...query
        };
        bee.get(req)
        .then(res => {
            console.log("Group results ", res);
            if (success) {
                success(res);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    post_promotion_view(query, success, fail) {
        var post_data = {
            promotion_id: query.id,
            context: query.context,
            page: query.page,
            section: query.section,
            view_on: query.today_str,
            _time_view_on_timestamp: query.today_str,
        };
        var _w = [];
        if(query.user_id > 0){
            _w = [
                ["user_id","e",query.user_id],
            ];
            post_data["user_id"] = query.user_id;
        }else{
            //use ip address
            _w = [
                ["user_id","e","_fx__ipaddress_"]
            ]
            post_data["_ipaddress_user_id"] = "";
        }
        //todays date :view_on_timestamp
        _w = [
            [
                [
                    [
                        _w[0],
                        "AND",
                        ["view_on_timestamp","gte",query.start_time]
                    ],
                    "AND",
                    ["view_on_timestamp","lte",query.end_time]
                ],
                "AND",
                ["promotion_id","e", query.id]
            ]
        ];

        bee
        .que()
        .get({
            promotion_views:{
                _w: _w
            },
            // _sql:{}
        },"check_if_trucked_today")
        .post({
            promotion_view: post_data
        },"post_view")
        .before("post_view", (index, previous_res, tasks) => {
            //console.log("staff is real ", previous_res);
            if (parseInt(previous_res.promotion_views.length) > 0) {
                return "skip";
            }
            return tasks[parseInt(index)].nectar;
        }) 
        .update({
            promotion: {
                views_count: parseInt(query.current_views_count) + 1,
                _w: [
                    ["id","e", query.id]
                ]
            }
        },"update_views") 
        .before("update_views", (index, previous_res, tasks) => {
            //console.log("staff is real ", previous_res, tasks);
            if(previous_res._skipped && previous_res._skipped == true) {
                return "skip";
            }
            return tasks[parseInt(index)].nectar;
        }) 
        .send()
        .then(res => {
            // console.log("res" , res);
            if (res[1].response._skipped && res[1].response._skipped == true) {
                if (fail) {
                    fail(["This user already viwed this promotion today"]);
                    return;
                }
            } 
            if (success) {
                success(res[1].response.promotion_view);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
}